import Vue from 'vue'
import Vuex from 'vuex'
// import app from './center'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count:1,
  },
  mutations: {

  },
  actions: {
  },
  modules: {
    // app
  },
  getters
})
